export const ProposalWantedBadgeIcon = () => (
  <svg width="34" height="18" viewBox="0 0 34 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="34" height="18" rx="2.95132" fill="#FFF1E5" />
    <path
      d="M29.8248 5.63018V6.66312H28.6414V7.59578H29.8248V8.6588H28.6414V9.81208H27.3577V4.42676H28.6414V5.63018H29.8248ZM21.461 7.14449C21.4559 5.85582 22.539 4.92317 23.9681 4.92818C25.3821 4.92317 26.4552 5.85582 26.4552 7.14449C26.4552 8.46324 25.3821 9.38587 23.9681 9.38085C22.539 9.38587 21.4559 8.46324 21.461 7.14449ZM22.4939 11.206V10.1731H28.6414V13.5527H27.3577V11.206H22.4939ZM22.7246 7.14449C22.7145 7.88159 23.251 8.30279 23.9681 8.29777C24.6701 8.30279 25.2066 7.88159 25.2116 7.14449C25.2066 6.43247 24.6701 6.01628 23.9681 6.0213C23.251 6.01628 22.7145 6.43247 22.7246 7.14449Z"
      fill="#E16F24"
    />
    <path
      d="M20.4435 4.42676V13.5527H19.2401V4.42676H20.4435ZM12.3906 10.7548C14.2409 9.66165 15.0532 8.33287 15.2287 6.54278H12.9221V5.50984H16.5023C16.5023 5.96614 16.4722 6.40739 16.4171 6.83361H17.3247V4.62733H18.5381V13.1516H17.3247V10.143H16.031V9.11008H17.3247V7.86655H16.2065C15.7803 9.37584 14.8476 10.6445 13.1428 11.6573L12.3906 10.7548Z"
      fill="#E16F24"
    />
    <path
      d="M8.51803 5.24934V11.3768H4.10547V5.24934H8.51803ZM5.38912 10.3639H7.27449V6.2522H5.38912V10.3639ZM10.0022 13.573V4.427H11.2959V13.573H10.0022Z"
      fill="#E16F24"
    />
  </svg>
);
